import { useStyles } from "./style";

export default function LoginSuccess() {
  const styles = useStyles();
  return (
    <div className={styles.loginsuccess}>
      <div
        style={{
          borderRadius: "6px",
          maxWidth: 520,
          background: "#fff",
          fontFamily: "Segoe UI, Arial, sans-serif",
          margin: "40px auto",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
          <svg width={26} height={26} style={{ marginRight: 12, minWidth: 26 }} viewBox="0 0 24 24" fill="none">
            <rect width="24" height="24" rx="6" fill="#2ecc40" />
            <path d="M7 13l3 3 7-7" stroke="#fff" strokeWidth="2.2" fill="none" />
          </svg>
          <span style={{ fontWeight: 700, fontSize: 22 }}>You're signed in!</span>
        </div>
        <div style={{ fontSize: 17 }}>
          You can now close this window and return to the <b>AlphaScript</b> ribbon to start using the tools.
        </div>
      </div>
    </div>
  );
}
